var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.836,
    height: 27.994,
    viewBox: "0 0 44.836 27.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4541",
    "data-name": "Rectangle 4541",
    width: 43.194,
    height: 25.042,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 0, 3.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M6.1,38.285a4.571,4.571,0,0,1,.131-1.772,9.147,9.147,0,0,1,.853-1.882,5.308,5.308,0,0,1,1.181-1.269,5.08,5.08,0,0,1,1.51-.809,4.881,4.881,0,0,1,1.313-.219,5.9,5.9,0,0,1,2.122.284c.411.143.957.4.984.416.163.078.3.147.394.2,0,0-6.559-.895-8.488,5.054",
    transform: "translate(-4.03 -21.475)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M33.648,16.636a7.121,7.121,0,0,1,.2-2.76,14.223,14.223,0,0,1,1.329-2.931,8.271,8.271,0,0,1,1.84-1.976,7.918,7.918,0,0,1,2.351-1.261,7.6,7.6,0,0,1,2.045-.341,9.183,9.183,0,0,1,3.305.443c.641.224,1.491.627,1.534.648.255.122.465.229.613.307,0,0-10.216-1.393-13.221,7.871",
    transform: "translate(-22.319 -4.887)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M43.851,18.011a6.426,6.426,0,0,1-9.864,5.432,10.026,10.026,0,0,1-12.7-.02,6.421,6.421,0,0,1-9.524-1.054,6.429,6.429,0,1,1-.641-11.327A10.019,10.019,0,0,1,28.9,5.733a10.036,10.036,0,0,1,7.916,5.878c.2-.02.4-.03.608-.03A6.43,6.43,0,0,1,43.851,18.011Z",
    transform: "translate(-1.329 -1.329)",
    fill: "none",
    stroke: "#0f475d",
    strokeWidth: 1.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderCloud);
export default __webpack_public_path__ + "static/media/sliderCloud.957a4765182ab6e86bb342499c6724da.svg";
export { ForwardRef as ReactComponent };